// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"44fcaa25","605":"3e1f844a"}[chunkId] + ".chunk.css";
};